import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/store';
import { Vertragspartner, Signatur } from '@/models/VertragspartnerModels';

export type Getters = {
  vertragspartner(state: State): Array<Vertragspartner>;
  signaturen(state: State): Array<Signatur>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  vertragspartner(state: State): Array<Vertragspartner> {
    return state.vertragspartner;
  },

  signaturen(state: State): Array<Signatur> {
    return state.signaturen;
  },
};
